"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEmbeddedContentTitleProperty = exports.embeddedContentTitlePropertyDefinition = void 0;
exports.embeddedContentTitlePropertyDefinition = {
    view: {
        label: 'Related Content Title',
        style: 'h3',
    },
    constraints: [
        {
            name: 'maxLength',
            argument: 72,
        },
    ],
    type: 'text',
    multiple: false,
    name: 'embedded-content-title',
};
const isEmbeddedContentTitleProperty = (prop) => {
    return prop.name === exports.embeddedContentTitlePropertyDefinition.name;
};
exports.isEmbeddedContentTitleProperty = isEmbeddedContentTitleProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZW1iZWRkZWQtY29udGVudC10aXRsZS5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL2VtYmVkZGVkLWNvbnRlbnQtdGl0bGUucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSxzQ0FBc0MsR0FBRztJQUNwRCxJQUFJLEVBQUU7UUFDSixLQUFLLEVBQUUsdUJBQXVCO1FBQzlCLEtBQUssRUFBRSxJQUFJO0tBQ1o7SUFDRCxXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxXQUFXO1lBQ2pCLFFBQVEsRUFBRSxFQUFFO1NBQ2I7S0FDRjtJQUNELElBQUksRUFBRSxNQUFNO0lBQ1osUUFBUSxFQUFFLEtBQUs7SUFDZixJQUFJLEVBQUUsd0JBQXdCO0NBQ0MsQ0FBQTtBQUkxQixNQUFNLDhCQUE4QixHQUFHLENBQUMsSUFBa0IsRUFBd0MsRUFBRTtJQUN6RyxPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssOENBQXNDLENBQUMsSUFBSSxDQUFBO0FBQ2xFLENBQUMsQ0FBQTtBQUZZLFFBQUEsOEJBQThCLGtDQUUxQyJ9